import { normalizeIdeaName } from './searchMealIdeas';

/**
 * What a meal on the calendar is called. A meal idea named for a generic item, and narrowed in its
 * ingredients to one kind of it, goes by that kind: a "Cereal" idea whose Cereal is Trix shows as
 * Trix. Any other meal, a "Tacos" with corn tortillas among them, keeps its own name.
 *
 * @param {{name: string}} meal
 * @param {{name: string, ingredients?: Array<{name: string, grocery_item_id: number, generic: ?{id: number, name: string}}>}|null} idea
 *        the meal's idea, if it has one
 */
export default function mealName(meal, idea) {
	if(!idea) {
		return meal.name;
	}
	const wanted = normalizeIdeaName(idea.name);
	const narrowed = (idea.ingredients || []).find((ingredient) => ingredient.generic
		&& ingredient.grocery_item_id !== ingredient.generic.id
		&& normalizeIdeaName(ingredient.generic.name) === wanted);
	return narrowed ? narrowed.name : meal.name;
}
